import { ROUTE_PATH } from "common/constants/sm-constants";
import { FormMetaModel, SmMetaInputModel, SmMetaSelectModel, SmDatepickerModel, SmBtnMetaModel } from "common/models/utility-models/meta-model";

export class CreditMetaModel extends FormMetaModel {
    constructor() {
        super('Add Credit', ROUTE_PATH.credit, '', 3);
    }

    override initProperties(): any {
        const formInfo = super.initProperties();
        const credits = new SmMetaInputModel(
            'credits',
            'credits',
            'input',
            true,
            'col-12 col-md-6 col-lg-6',
            2,
            4,
            'Credits',
            'number',
            '',
            false,
            true,
            true,
            false,
            2,
            1
        );
        const type_id = new SmMetaSelectModel(
            'type_id',
            'type_id',
            'select',
            true,
            'col-12 col-md-6 col-lg-6',
            1,
            1,
            'Type',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'type_name',
            'id',

        );
        const batch_id = new SmMetaSelectModel(
            'batch_id',
            'batch_id',
            'select',
            true,
            'col-12 col-md-6 col-lg-6',
            1,
            2,
            'Batch',
            'select',
            '',
            false,
            true,
            true,
            false,
            0,
            0,
            false,
            [],
            'batch_number',
            'id',

        );
        const yearSelected = new SmDatepickerModel(
            'yearSelected',
            'yearSelected',
            'datepicker',
            true,
            'col-12 col-md-6 col-lg-6',
            2,
            3,
            'Select Year',
            'text',
            '',
            false,
            true,
            true,
            false,
            false,
            'YYYY',
            new Date('1970-01-01'),
            new Date('2070-10-19'),
            false
        )

        const buttons = {
            submit: new SmBtnMetaModel('SUBMIT', '', true, false, true, true),
            isFormControl: false
        };
        return {
            formInfo,
            buttons,
            credits,
            type_id,
            batch_id,
            yearSelected
        }
    }


}